import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const packagingControllerRestUrl = detailServicesPath + '/details/packaging/orders/'

export default class PackagingControllerService {
    static async add(orderId, data) {
        return axios.patch(`${packagingControllerRestUrl}${orderId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addByDetailId(orderId, detailId, data) {
        return axios.patch(`${packagingControllerRestUrl}${orderId}/details/${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async remove(orderId, data) {
        return axios.patch(`${packagingControllerRestUrl}${orderId}/remove`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async removeByDetailId(orderId, detailId) {
        return axios.patch(`${packagingControllerRestUrl}${orderId}/details/${detailId}/remove`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}